import React, { useEffect, ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../store/rootState';
import { actions } from '../../store/modules/Auth';
import { selectAuth } from '../../store/modules/Auth/selectors';

type Props = {
  children: ReactNode;
};

// 現状は認証用APIをfetchする以外のロジックを実行していない
const FetchAuth: React.SFC<Props> = ({ children }: Props) => {
  const loaded = useSelector((state: RootState) => selectAuth(state).loaded);
  const dispatch = useDispatch();

  useEffect(() => {
    // 認証のAPIをfetch済みの場合、処理をスキップする
    if (loaded) return;

    // 認証用APIを呼ぶ
    dispatch(actions.fetchAuthRequest());
  }, [loaded, dispatch]);

  return <>{children}</>;
};

export default FetchAuth;
